import { InjectionToken } from '@angular/core';
import { DOCUMENT_TYPE_META } from './helper/document-form/map-document-type';

export const SOFTLINE_MODULE_SALES = 'wws-sales';
export const SOFTLINE_MODULE_DOCUMENT_QUERY = 'wws-document-query';
export const SOFTLINE_PERMISSION_WWS_SALES = 'SOFTAPPS.WWS_SALES';

export interface AgingBucket {
  label: string;
  /** Inclusive lower bound (days from filterTo). 0 = today. */
  fromDays: number;
  /** Inclusive upper bound (days from filterTo). null = open-ended (e.g. ">30 Tage"). */
  toDays: number | null;
  /** Hex color (e.g. "#16a34a") used for the legend dot and progress bar segment. */
  color: string;
}

/** Default aging buckets used for any belegart without explicit overrides in
    the per-type config. Mirrors the standard <7/7-14/14-30/>30 layout. */
export const DEFAULT_AGING_BUCKETS: readonly AgingBucket[] = [
  { label: '< 7 Tage', fromDays: 0, toDays: 7, color: '#16a34a' },
  { label: '7 - 14 Tage', fromDays: 7, toDays: 14, color: '#eab308' },
  { label: '14 - 30 Tage', fromDays: 14, toDays: 30, color: '#f97316' },
  { label: '> 30 Tage', fromDays: 30, toDays: null, color: '#ef4444' },
];

export interface SalesModuleConfig {
  /** Fixed start date for document queries  */
  dateFrom?: string | null;
  /** Valid document types (keys from DOCUMENT_TYPE_META). Empty = all allowed */
  validDocumentTypes?: string[];
  /** Default document type key for new document creation */
  defaultDocumentType?: string | null;
  /** How many months back to load documents on the dashboard */
  monthsBack?: number;
  /** Default distribution type id for new document creation */
  defaultDistributionType?: string | null;
  /** Aging buckets per document type. Presence enables the aging toggle on the card. */
  agingBuckets?: Partial<Record<string, AgingBucket[]>>;
  /** Indent sub-positions in the positions grid's Position column */
  indentPositions?: boolean;
}

export const SOFTLINE_CONFIG_WWS_SALES = new InjectionToken<SalesModuleConfig>(
  'SOFTLINE_CONFIG_WWS_SALES',
  {
    factory: () => DEFAULT_SALES_CONFIG,
  }
);

export const DEFAULT_SALES_CONFIG: Required<SalesModuleConfig> = {
  dateFrom: null,
  validDocumentTypes: Object.keys(DOCUMENT_TYPE_META),
  defaultDocumentType: null,
  monthsBack: 12,
  defaultDistributionType: null,
  agingBuckets: {},
  indentPositions: true,
};
